export const getMonthNames = (locale, format = 'long') => {
    return Array.from({ length: 12 }, (_, i) => new Intl.DateTimeFormat(locale, { month: format }).format(new Date(2000, i, 1)));
};
export const getWeekDayNames = (locale, format = 'short') => {
    const baseDate = new Date(Date.UTC(2021, 5, 6));
    return Array.from({ length: 7 }, (_, i) => {
        const date = new Date(baseDate);
        date.setDate(baseDate.getDate() + i);
        return new Intl.DateTimeFormat(locale, { weekday: format }).format(date);
    });
};
